import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { SeparatorProps } from "./types";

const Separator = ({ isListSeparator, ...props }: SeparatorProps) => {
    const { gray300 } = colors;

    return isListSeparator ? (
        <li
            {...props}
            css={css({
                height: "1px",
                background: gray300
            })}
        />
    ) : (
        <div
            {...props}
            css={css({
                height: "1px",
                background: gray300
            })}
        />
    );
};

export default Separator;
